module.exports = __webpack_public_path__ + "static/media/donttouch.6adb1ad9.png";